<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<!-- Loading Overlay for Modal Data -->
			<div v-if="loadModalData" class="loading-overlay">
				<div class="loading-spinner">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading ...</span>
					</div>
					<p class="mt-3">Loading Data ...</p>
				</div>
			</div>
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-hand-holding-usd"
												></i
												>&nbsp;&nbsp;Finance&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Tour Invoices&nbsp;&nbsp;</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12">
									<div class="col-sm-7 float-sm-left text-start"></div>
									<div
										class="col-sm-5 d-flex justify-content-end gap-1"
										style="font-family: HeaderCustomFont"
									>
										<!-- @click="openModal(modal, data)" -->
										<button
											:disabled="!currentRoute"
											class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
											@click="openModal('invoices')"
										>
											<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
											Invoice
										</button>
										<button
											v-if="currentRoute"
											class="btn text-none bg-info float-sm-right text-white rounded-0"
											@click="openModal('preview')"
										>
											<i class="nav-icon fas fa-print"></i>&nbsp;&nbsp;Preview
											Invoice
										</button>
									</div>
								</div>
								<div class="row col-sm-12 mt-2">
									<div class="mb-1">
										<label for="agent_id" class="form-label"
											>Select Invoice</label
										>
										<v-autocomplete
											density="compact"
											variant="outlined"
											rounded="0"
											return-object
											placeholder="Select Invoice"
											:items="invoicesComputed"
											v-model="selectedInvoice"
											@update:modelValue="selectInvoice($event)"
											:item-title="invoiceSelect"
											item-value="id"
											clearable
										>
										</v-autocomplete>
									</div>
									<div class="table-responsive p-3 d-none">
										<v-data-table
											v-model:items-per-page="invoicesPerPage"
											:headers="invoiceHeaders"
											:items="invoicesComputed"
											:search="searchInvoices"
											density="compact"
											item-value="name"
											class="d-none table-sm table-striped rounded-0 text-truncate table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													v-for="(item, index) in items"
													:key="item.id"
													@click="selectInvoice(item)"
													class="clickable-row"
													:class="{
														'selected-row':
															selectedInvoice && item.id === selectedInvoice.id,
													}"
												>
													<td>{{ index + 1 }}</td>
													<td>{{ item.reference }}</td>
													<td>{{ item.client_ref }}</td>
													<!-- <td>{{ item.bill_to }}</td> -->
													<td>{{ item.agent ? item.agent.name : "None" }}</td>
													<!-- <td>{{ item.address }}</td> -->
													<td>{{ this.formatDate(item.invoice_date) }}</td>
													<td class="">
														<v-menu v-if="currentRoute" offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageInvoices(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageInvoices(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>

				<!-- Invoice PDF Preview Section (moved above Payable Items) -->
				<div class="row card-body mt-0" v-if="!currentRoute">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body mb-4 p-4">
								<h5 class="mb-3 custom-header font-size-15 text-dark">
									Invoice Preview:
									{{ selectedInvoice ? selectedInvoice.reference : "" }}
								</h5>
								<div v-if="selectedInvoice" class="d-none">
									<iframe
										v-if="pdfDocument !== ''"
										:src="pdfDocument"
										width="100%"
										height="650px"
										style="border: none"
									></iframe>
									<div v-else class="text-center text-muted pt-10">
										No document to display.
									</div>
								</div>

								<div
									v-if="pdfLoading"
									class="d-flex justify-center align-center"
									style="height: 650px"
								>
									<div class="text-center">
										<div class="spinner-border text-primary" role="status">
											<span class="visually-hidden">Generating PDF ...</span>
										</div>
										<p class="mt-3">Generating document ...</p>
									</div>
								</div>
								<div v-else class="overflow-y-auto p-4" style="height: 650px">
									<iframe
										v-if="pdfDocument !== ''"
										:src="pdfDocument"
										width="100%"
										height="650px"
										style="border: none"
									></iframe>
									<div v-else class="text-center text-muted pt-10">
										No document to display.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4" v-if="currentRoute">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.invoicePayables">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Invoice Payable Items
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														v-if="this.selectedInvoice"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('payables')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Payable Item
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchPayables"
														label="Search Invoice Payables"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="payablesPerPage"
														:headers="payableHeaders"
														:items="filteredPayables"
														:search="searchPayables"
														density="compact"
														item-value="id"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<template v-if="selectedInvoice">
																<tr
																	v-for="(item, index) in items"
																	:key="item.id"
																>
																	<!-- <td>{{ index + 1 }}</td> -->
																	<td>
																		{{
																			item.invoice
																				? item.invoice.reference
																				: "N/A"
																		}}
																	</td>
																	<td>{{ item.service }}</td>
																	<td>{{ item.description }}</td>
																	<td>
																		{{ formatCurrency(item.unit_cost, "", 2) }}
																	</td>
																	<td>{{ item.qty }}</td>
																	<td>
																		{{ formatCurrency(item.total, "", 2) }}
																	</td>
																	<td class="">
																		<v-menu v-if="currentRoute" offset-y>
																			<template v-slot:activator="{ props }">
																				<v-icon v-bind="props" size="24">
																					mdi-dots-horizontal
																				</v-icon>
																			</template>

																			<v-list
																				density="compact"
																				class="custom-dropdown"
																			>
																				<v-list-item
																					@click="managePayables(item, 'edit')"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-regular fa-pen-to-square"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																					>
																				</v-list-item>
																				<v-list-item
																					@click="
																						managePayables(item, 'delete')
																					"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-solid fa-trash"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																					>
																				</v-list-item>
																			</v-list>
																		</v-menu>
																	</td>
																</tr></template
															>
														</template>
														<template v-slot:body.append="{ items }">
															<template v-if="selectedInvoice">
																<tr
																	class="font-weight-bold"
																	style="font-family: HeaderCustomFont"
																>
																	<td colspan="5" class="text-end">
																		Invoice Total
																	</td>
																	<td>
																		{{
																			formatCurrency(
																				items
																					.reduce(
																						(sum, item) =>
																							sum + Number(item.total || 0),
																						0
																					)
																					.toFixed(2),
																				"",
																				2
																			)
																		}}
																	</td>
																	<td></td>
																</tr> </template
														></template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>

				<!-- Payment Schedule Section -->
				<div class="row card-body mt-0 p-4" v-if="currentRoute">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.invoicePayables">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Payment Schedule
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														v-if="this.selectedInvoice"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('schedules')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Schedule Item
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchSchedules"
														label="Search Invoice Payables"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="schedulesPerPage"
														:headers="scheduleHeaders"
														:items="filteredSchedules"
														:search="searchSchedules"
														density="compact"
														item-value="id"
														class="table-sm table-striped rounded-0 table-responsive table-wrap text-start align-top"
													>
														<template v-slot:body="{ items }">
															<template v-if="selectedInvoice">
																<tr v-for="item in items" :key="item.id">
																	<!-- <td> {{ item.invoice ? item.invoice.reference : 'N/A' }} </td> -->
																	<td>{{ item.payt_category }}</td>
																	<td>{{ item.payt_percentage }}%</td>
																	<td>{{ item.plan_desc }}</td>
																	<!-- <td>{{ item.unit_cost }}</td> -->
																	<td>{{ item.qty }}</td>
																	<td>
																		{{ formatCurrency(item.total_due, "", 2) }}
																	</td>
																	<td>
																		{{ this.formatDate(item.payable_date) }}
																	</td>
																	<td class="">
																		<v-menu v-if="currentRoute" offset-y>
																			<template v-slot:activator="{ props }">
																				<v-icon v-bind="props" size="24">
																					mdi-dots-horizontal
																				</v-icon>
																			</template>
																			<v-list
																				density="compact"
																				class="custom-dropdown"
																			>
																				<v-list-item
																					@click="manageSchedules(item, 'edit')"
																				>
																					<v-list-item-title>
																						<font-awesome-icon
																							icon="fa-regular fa-pen-to-square"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Edit
																					</v-list-item-title>
																				</v-list-item>
																				<v-list-item
																					@click="
																						manageSchedules(item, 'delete')
																					"
																				>
																					<v-list-item-title>
																						<font-awesome-icon
																							icon="fa-solid fa-trash"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Delete
																					</v-list-item-title>
																				</v-list-item>
																			</v-list>
																		</v-menu>
																	</td>
																</tr>
															</template>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4" v-if="currentRoute">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.invoicePayments">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Payments
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														v-if="this.selectedInvoice"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('payments')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
														Payment
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchPayments"
														label="Search Payments"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="paymentsPerPage"
														:headers="paymentHeaders"
														:items="filteredPayments"
														:search="searchPayments"
														density="compact"
														item-value="id"
														class="table-sm table-striped rounded-0 table-responsive table-wrap text-start align-top"
													>
														<template v-slot:body="{ items }">
															<template v-if="selectedInvoice">
																<tr
																	v-for="(item, index) in items"
																	:key="item.id"
																>
																	<td>{{ index + 1 }}</td>
																	<td>{{ item.payt_category }}</td>
																	<td>
																		{{ formatCurrency(item.payt_total, "", 2) }}
																	</td>
																	<td>{{ item.payt_percentage }}%</td>
																	<td>{{ item.payt_desc }}</td>
																	<td>
																		{{ this.formatDate(item.payable_date) }}
																	</td>
																	<td class="">
																		<v-menu v-if="currentRoute" offset-y>
																			<template v-slot:activator="{ props }">
																				<v-icon v-bind="props" size="24">
																					mdi-dots-horizontal
																				</v-icon>
																			</template>

																			<v-list
																				density="compact"
																				class="custom-dropdown"
																			>
																				<v-list-item
																					@click="managePayments(item, 'edit')"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-regular fa-pen-to-square"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																					>
																				</v-list-item>
																				<v-list-item
																					@click="
																						managePayments(item, 'delete')
																					"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-solid fa-trash"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																					>
																				</v-list-item>
																			</v-list>
																		</v-menu>
																	</td>
																</tr>
															</template>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4" v-if="currentRoute">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.supplierPayments">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Supplier Payments
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<button
														:disabled="!currentRoute"
														v-if="this.selectedInvoice"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('suppliers')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
														Payment
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchSuppliers"
														label="Search Supplier Payments"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="suppliersPerPage"
														:headers="supplierHeaders"
														:items="filteredSupplierPayts"
														:search="searchSuppliers"
														density="compact"
														item-value="id"
														class="table-sm table-striped rounded-0 table-responsive table-wrap text-start align-top"
													>
														<template v-slot:body="{ items }">
															<template v-if="selectedInvoice">
																<tr
																	v-for="(item, index) in items"
																	:key="item.id"
																>
																	<td>{{ index + 1 }}</td>
																	<td>{{ item.supplier.name }}</td>
																	<td>{{ item.type.name }}</td>
																	<td>
																		{{ formatCurrency(item.amount, "", 2) }}
																	</td>
																	<td>
																		{{ formatCurrency(item.amount_ugx, "", 0) }}
																	</td>
																	<td>{{ item.payment_status }}</td>
																	<td class="">
																		<v-menu v-if="currentRoute" offset-y>
																			<template v-slot:activator="{ props }">
																				<v-icon v-bind="props" size="24">
																					mdi-dots-horizontal
																				</v-icon>
																			</template>

																			<v-list
																				density="compact"
																				class="custom-dropdown"
																			>
																				<v-list-item
																					@click="
																						manageSupplierPayts(item, 'edit')
																					"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-regular fa-pen-to-square"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																					>
																				</v-list-item>
																				<v-list-item
																					@click="
																						manageSupplierPayts(item, 'delete')
																					"
																				>
																					<v-list-item-title
																						><font-awesome-icon
																							icon="fa-solid fa-trash"
																						/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																					>
																				</v-list-item>
																			</v-list>
																		</v-menu>
																	</td>
																</tr>
															</template>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>
			</div>

			<v-dialog v-model="invoicesModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageInvoices(this.tourInvoice, 'update')
								: manageInvoices(this.tourInvoice, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-hand-holding-usd"
									/>&nbsp;&nbsp;Tour Invoice
								</h5>
							</div>
							<v-icon class="cursor-pointer" @click="closeModal('invoices')"
								>mdi-close</v-icon
							>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="">
												<label for="client_id" class="form-label"
													><span
														v-if="tourInvoice.errors.has('tour_id')"
														class="text-danger text-lowercase"
													>
														{{ tourInvoice.errors.get("tour_id") }} </span
													><span v-else>Select Tour</span></label
												>
												<!-- editMode ? (item) => item.details || tourSelect(item) : tourSelect -->
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													:items="this.infiniteTours.data"
													placeholder="Select Registerd Tour"
													v-model="tourInvoice.tour_id"
													@update:modelValue="selectTour($event)"
													:item-title="
														editMode
															? (item) => item.details || tourSelect(item)
															: tourSelect
													"
													item-value="id"
													clearable
												></v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-3 required">
											<label for="name" class="form-label"
												><span
													v-if="tourInvoice.errors.has('reference')"
													class="text-danger text-lowercase"
												>
													{{ tourInvoice.errors.get("reference") }} </span
												><span v-else>Reference Number</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Reference Number"
												v-model="tourInvoice.reference"
												id="reference"
											></v-text-field>
										</div>
										<div class="col-md-3">
											<label for="invoice_date" class="form-label"
												><span
													v-if="tourInvoice.errors.has('invoice_date')"
													class="text-danger text-lowercase"
												>
													{{ tourInvoice.errors.get("invoice_date") }} </span
												><span v-else>Invoice Date</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												type="date"
												clearable
												placeholder="Invoice Date"
												v-model="tourInvoice.invoice_date"
												id="invoice_date"
											></v-text-field>
										</div>
										<div class="col-md-6">
											<div class="">
												<label for="client_ref" class="form-label"
													><span
														v-if="tourInvoice.errors.has('client_ref')"
														class="text-danger text-lowercase"
													>
														{{ tourInvoice.errors.get("client_ref") }} </span
													><span v-else>Client</span></label
												>
												<!-- @update:modelValue="selectGuest($event)" -->
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													disabled
													placeholder="Client Reference"
													v-model="tourInvoice.client_ref"
													id="client_ref"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-6 required">
											<div class="mb-3">
												<label for="bill_to" class="form-label"
													><span
														v-if="tourInvoice.errors.has('bill_to')"
														class="text-danger text-lowercase"
													>
														{{ tourInvoice.errors.get("bill_to") }} </span
													><span v-else>Bill To</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Address Bill To ..."
													v-model="tourInvoice.bill_to"
													id="bill_to"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-6">
											<div class="mb-3">
												<label for="agent_id" class="form-label"
													><span
														v-if="tourInvoice.errors.has('agent_id')"
														class="text-danger text-lowercase"
													>
														{{ tourInvoice.errors.get("agent_id") }} </span
													><span v-else>Agent</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													disabled
													return-object
													placeholder="Select Agent"
													:items="this.infiniteAgents.data"
													v-model="tourInvoice.agent_id"
													item-value="id"
													item-title="name"
													id="agent_id"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="">
												<label for="address" class="form-label"
													><span
														v-if="tourInvoice.errors.has('address')"
														class="text-danger text-lowercase"
													>
														{{ tourInvoice.errors.get("address") }} </span
													><span v-else>Address</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Invoice Address"
													v-model="tourInvoice.address"
													id="address"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Invoice
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('invoices')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="payablesModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? managePayables(this.invoicePayable, 'update')
								: managePayables(this.invoicePayable, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-hand-holding-usd"
									/>&nbsp;&nbsp;Invoice Payable
								</h5>
							</div>
							<v-icon class="cursor-pointer" @click="closeModal('payables')"
								>mdi-close</v-icon
							>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="service" class="form-label"
												><span
													v-if="invoicePayable.errors.has('service')"
													class="text-danger text-lowercase"
												>
													{{ invoicePayable.errors.get("service") }} </span
												><span v-else>Service Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Service Category"
												:items="['Safari Guests', 'Gorilla Permit', 'Extras']"
												v-model="invoicePayable.service"
												@update:modelValue="selectItem($event, 'activity')"
												id="service"
											>
											</v-autocomplete>
										</div>

										<div class="col-md-3 required">
											<div class="">
												<label for="qty" class="form-label"
													><span
														v-if="invoicePayable.errors.has('qty')"
														class="text-danger text-lowercase"
													>
														{{ invoicePayable.errors.get("qty") }} </span
													><span v-else>Pax</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Number of Pax"
													v-model="invoicePayable.qty"
													@update:modelValue="selectItem($event, 'pax')"
													id="qty"
												></v-text-field>
											</div>
										</div>
										<div
											class="col-md-6 required"
											v-if="
												invoicePayable.service &&
												invoicePayable.qty &&
												invoicePayable.service == 'Extras'
											"
										>
											<label for="extra_id" class="form-label"
												><span
													v-if="invoicePayable.errors.has('extra_id')"
													class="text-danger text-lowercase"
												>
													{{ invoicePayable.errors.get("extra_id") }} </span
												><span v-else>Tour Activity</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Tour Activity"
												:items="this.infiniteActivities.data"
												v-model="invoicePayable.extra_id"
												@update:modelValue="selectItem($event, 'extras')"
												item-value="id"
												item-title="activity_name"
												id="extra_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="unit_cost" class="form-label"
													><span
														v-if="invoicePayable.errors.has('unit_cost')"
														class="text-danger text-lowercase"
													>
														{{ invoicePayable.errors.get("unit_cost") }} </span
													><span v-else>Unit Cost</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Unit Cost ($)"
													v-model="invoicePayable.unit_cost"
													id="unit_cost"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="description" class="form-label"
													><span
														v-if="invoicePayable.errors.has('description')"
														class="text-danger text-lowercase"
													>
														{{
															invoicePayable.errors.get("description")
														}} </span
													><span v-else>Description</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Payable Description"
													v-model="invoicePayable.description"
													id="description"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Item
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('payables')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="schedulesModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageSchedules(this.invoiceSchedule, 'update')
								: manageSchedules(this.invoiceSchedule, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-hand-holding-usd"
									/>&nbsp;&nbsp;Payment Schedule
								</h5>
							</div>
							<v-icon class="cursor-pointer" @click="closeModal('schedules')"
								>mdi-close</v-icon
							>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-4 required">
											<label for="payt_category" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('payt_category')"
													class="text-danger text-lowercase"
												>
													{{
														invoiceSchedule.errors.get("payt_category")
													}} </span
												><span v-else>Payment Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Payment Category"
												:items="['Deposit Payment', 'Final Payment']"
												v-model="invoiceSchedule.payt_category"
												id="payt_category"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-5 required">
											<label for="service" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('service')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("service") }} </span
												><span v-else>Service Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Service Category"
												:items="['Safari Guests', 'Gorilla Permit', 'Extras']"
												v-model="invoiceSchedule.service"
												@update:modelValue="selectSchedule($event, 'activity')"
												id="service"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3">
											<label for="qty" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('qty')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("qty") }} </span
												><span v-else>Pax</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Enter Number of Pax"
												v-model="invoiceSchedule.qty"
												@update:modelValue="selectSchedule($event, 'pax')"
												id="qty"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1">
										<div
											class="col-md-6 required"
											v-if="
												invoiceSchedule.service &&
												invoiceSchedule.qty &&
												invoiceSchedule.service == 'Extras'
											"
										>
											<label for="activity_id" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('activity_id')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("activity_id") }} </span
												><span v-else>Tour Activity</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Tour Activity"
												:items="this.infiniteActivities.data"
												v-model="invoiceSchedule.activity_id"
												@update:modelValue="selectSchedule($event, 'extras')"
												item-value="id"
												item-title="activity_name"
												id="activity_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3 required">
											<label for="payt_percentage" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('payt_percentage')"
													class="text-danger text-lowercase"
												>
													{{
														invoiceSchedule.errors.get("payt_percentage")
													}} </span
												><span v-else>Percentage</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Enter Percentage"
												v-model="invoiceSchedule.payt_percentage"
												id="payt_percentage"
											></v-text-field>
										</div>

										<div class="col-md-3">
											<label for="unit_cost" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('unit_cost')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("unit_cost") }} </span
												><span v-else>Unit Cost</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Enter Unit Cost"
												v-model="invoiceSchedule.unit_cost"
												id="unit_cost"
											></v-text-field>
										</div>
										<div class="col-md-6 required">
											<label for="plan_desc" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('plan_desc')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("plan_desc") }} </span
												><span v-else>Description</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Enter Description"
												v-model="invoiceSchedule.plan_desc"
												id="plan_desc"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<label for="payable_date" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('payable_date')"
													class="text-danger text-lowercase"
												>
													{{
														invoiceSchedule.errors.get("payable_date")
													}} </span
												><span v-else>Payable Date</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												type="date"
												placeholder="Enter Date"
												v-model="invoiceSchedule.payable_date"
												id="payable_date"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<label for="total_due" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('total_due')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("total_due") }} </span
												><span v-else>Payable Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												disabled
												placeholder="Total Due"
												v-model="invoiceSchedule.total_due"
												id="total_due"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1 d-none">
										<div class="col-md-3 required">
											<label for="payable_date" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('payable_date')"
													class="text-danger text-lowercase"
												>
													{{
														invoiceSchedule.errors.get("payable_date")
													}} </span
												><span v-else>Payable Date</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												type="date"
												placeholder="Enter Date"
												v-model="invoiceSchedule.payable_date"
												id="payable_date"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<label for="total_due" class="form-label"
												><span
													v-if="invoiceSchedule.errors.has('total_due')"
													class="text-danger text-lowercase"
												>
													{{ invoiceSchedule.errors.get("total_due") }} </span
												><span v-else>Payable Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												disabled
												placeholder="Total Due"
												v-model="invoiceSchedule.total_due"
												id="total_due"
											></v-text-field>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Plan
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('schedules')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="paymentsModal" max-width="900px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? managePayments(this.invoicePayment, 'update')
								: managePayments(this.invoicePayment, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-hand-holding-usd"
									/>&nbsp;&nbsp;Invoice Payments
								</h5>
							</div>
							<v-icon class="cursor-pointer" @click="closeModal('payments')"
								>mdi-close</v-icon
							>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="payt_category" class="form-label"
												><span
													v-if="invoicePayment.errors.has('payt_category')"
													class="text-danger text-lowercase"
												>
													{{
														invoicePayment.errors.get("payt_category")
													}} </span
												><span v-else>Service Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Service Category"
												:items="['Deposit Payment', 'Final Payment']"
												v-model="invoicePayment.payt_category"
												id="payt_category"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="payt_total" class="form-label"
													><span
														v-if="invoicePayment.errors.has('payt_total')"
														class="text-danger text-lowercase"
													>
														{{ invoicePayment.errors.get("payt_total") }} </span
													><span v-else>Amount Paid</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Amount"
													v-model="invoicePayment.payt_total"
													id="payt_total"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="payable_date" class="form-label"
													><span
														v-if="invoicePayment.errors.has('payable_date')"
														class="text-danger text-lowercase"
													>
														{{
															invoicePayment.errors.get("payable_date")
														}} </span
													><span v-else>Date Paid</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													type="date"
													placeholder="Enter Date"
													v-model="invoicePayment.payable_date"
													id="payable_date"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="mb-3">
												<label for="payt_desc" class="form-label"
													><span
														v-if="invoicePayment.errors.has('payt_desc')"
														class="text-danger text-lowercase"
													>
														{{ invoicePayment.errors.get("payt_desc") }} </span
													><span v-else>Description</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Description"
													v-model="invoicePayment.payt_desc"
													id="payt_desc"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Payment
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('payments')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="supplierModal" max-width="900px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageSupplierPayts(this.supplierPayment, 'update')
								: manageSupplierPayts(this.supplierPayment, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-hand-holding-usd"
									/>&nbsp;&nbsp;Supplier Payments
								</h5>
							</div>
							<v-icon class="cursor-pointer" @click="closeModal('suppliers')"
								>mdi-close</v-icon
							>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-5 required">
											<label for="supplier_id" class="form-label"
												><span
													v-if="supplierPayment.errors.has('supplier_id')"
													class="text-danger text-lowercase"
												>
													{{ supplierPayment.errors.get("supplier_id") }} </span
												><span v-else>Supplier</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Supplier"
												:items="this.supplierList.data"
												v-model="supplierPayment.supplier_id"
												item-value="id"
												item-title="name"
												id="id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-4 required">
											<label for="payment_type" class="form-label"
												><span
													v-if="supplierPayment.errors.has('payment_type')"
													class="text-danger text-lowercase"
												>
													{{
														supplierPayment.errors.get("payment_type")
													}} </span
												><span v-else>Payment Type</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Payment Type"
												:items="this.costTypes.data"
												v-model="supplierPayment.payment_type"
												item-value="id"
												item-title="name"
												id="payment_type"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="date" class="form-label"
													><span
														v-if="supplierPayment.errors.has('date')"
														class="text-danger text-lowercase"
													>
														{{ supplierPayment.errors.get("date") }} </span
													><span v-else>Date Paid</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													type="date"
													placeholder="Enter Date"
													v-model="supplierPayment.date"
													id="date"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-4 required">
											<div class="">
												<label for="amount" class="form-label"
													><span
														v-if="supplierPayment.errors.has('amount')"
														class="text-danger text-lowercase"
														>{{ supplierPayment.errors.get("amount") }}</span
													><span v-else>Amount</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Amount"
													v-model="supplierPayment.amount"
													id="amount"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-3">
											<label for="payment_status" class="form-label"
												><span
													v-if="supplierPayment.errors.has('payment_status')"
													class="text-danger text-lowercase"
													>{{
														supplierPayment.errors.get("payment_status")
													}}</span
												><span v-else>Payment Status</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Payment Status"
												:items="['Pending', 'Cleared', 'Cancelled']"
												v-model="supplierPayment.payment_status"
												id="payment_status"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-5 required">
											<label for="currency" class="form-label"
												><span
													v-if="supplierPayment.errors.has('currency')"
													class="text-danger text-lowercase"
												>
													{{ supplierPayment.errors.get("currency") }}</span
												><span v-else>Currency</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Currency"
												:items="this.currencyList.data"
												v-model="supplierPayment.currency"
												item-value="id"
												item-title="currency"
												id="currency"
											>
											</v-autocomplete>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Payment
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('suppliers')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="previewModal" max-width="1250px" persistent>
				<v-card>
					<v-card-title class="d-flex justify-space-between align-center">
						<div class="modal-header">
							<h5
								class="modal-title font-size-20 text-dark"
								style="font-family: HeaderCustomFont"
							>
								<font-awesome-icon icon="fa-solid fa-print" />&nbsp;&nbsp;Tour
								Invoice
							</h5>
						</div>
						<v-icon @click="closeModal('preview')">mdi-close</v-icon>
					</v-card-title>

					<v-card-text class="pa-4">
						<div
							v-if="pdfLoading"
							class="d-flex justify-center align-center"
							style="height: 650px"
						>
							<div class="text-center">
								<div class="spinner-border text-primary" role="status">
									<span class="visually-hidden">Generating PDF ...</span>
								</div>
								<p class="mt-3">Generating document ...</p>
							</div>
						</div>
						<div v-else class="overflow-y-auto" style="height: 650px">
							<iframe
								v-if="pdfDocument !== ''"
								:src="pdfDocument"
								width="100%"
								height="650px"
								style="border: none"
							></iframe>
							<div v-else class="text-center text-muted pt-10">
								No document to display.
							</div>
						</div>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<div
							class="justify-content-start modal-footer"
							style="font-family: HeaderCustomFont"
						>
							<a
								v-if="pdfDocument !== ''"
								:href="pdfDocument"
								:download="`tour_invoice_${selectedInvoice?.reference}.pdf`"
								class="btn bg-green-custom text-white w-10 m-2"
							>
								<i class="fas fa-download"></i>&nbsp;&nbsp;Download
							</a>
							<button
								type="button"
								class="btn bg-danger square-button text-white w-10 m-2"
								@click="closeModal('preview')"
							>
								Close
							</button>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			selectedTour: null,
			selectedInvoice: null,
			message: "",
			http_code: "",
			user: [],
			loadModalData: false,
			invoiceData: false,
			paymentData: false,
			infiniteTourists: [],
			infiniteAgents: [],
			infiniteTours: [],
			infiniteActivities: [],
			costTypes: [],
			supplierList: [],
			currencyList: [],
			editMode: false,
			invoicesModal: false,
			payablesModal: false,
			paymentsModal: false,
			schedulesModal: false,
			supplierModal: false,
			previewModal: false,
			pdfDocument: "",
			pdfLoading: false,
			filterInvoices: new Form({
				start: null,
				end: null,
				tour: null,
			}),

			tourInvoice: new Form({
				id: "",
				reference: "",
				tour_id: null,
				client_ref: "",
				bill_to: "",
				agent_id: null,
				address: "",
				invoice_date: "",
				is_deleted: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			invoicePayable: new Form({
				id: "",
				invoice_id: null,
				service: null,
				extra_id: null,
				description: "",
				unit_cost: "",
				qty: "",
				total: "",
				is_deleted: "",
				created_at: "",
				created_by: "",
				updated_at: "",
				updated_by: "",
			}),
			invoicePayment: new Form({
				id: "",
				invoice_id: null,
				payt_category: null,
				payt_percentage: "",
				payt_desc: "",
				unit_cost: "",
				qty: "",
				payt_total: "",
				payable_date: "",
				amount_paid: "",
				is_deleted: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			invoiceSchedule: new Form({
				id: "",
				invoice_id: null,
				payt_category: null,
				service: null,
				activity_id: null,
				payt_percentage: "",
				plan_desc: "",
				unit_cost: "",
				qty: "",
				total_due: "",
				payable_date: "",
				amount_due: "",
				is_deleted: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			supplierPayment: new Form({
				id: "",
				invoice_id: null,
				supplier_id: null,
				user_id: null,
				payment_type: null,
				tour_id: null,
				currency: null,
				amount: "",
				amount_ugx: "",
				payment_status: null,
				date: "",
				cancelled_at: "",
				cancelled_by: "",
				cancellation_reason: "",
				approved_at: "",
				approved_by: "",
				method: "",
				notes: "",
				file: "",
				invoice_id: null,
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			searchInvoices: "",
			invoicesPerPage: 10,
			invoices: [],
			invoiceHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Invoice Ref", value: "reference", sortable: true },
				{ title: "Client", value: "client_ref", sortable: true },
				// { title: "Bill", value: "bill_to", sortable: true },
				{ title: "Agent", value: "agent_id", sortable: true },
				// { title: "Address", value: "address", sortable: true },
				{ title: "Date", value: "invoice_date", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],
			searchPayments: "",
			paymentsPerPage: 10,
			payments: [],
			paymentHeaders: [
				// { title: "#", value: "index", sortable: true },
				{ title: "Invoice Ref", value: "invoice_id", sortable: true },
				{ title: "Category", value: "payt_category", sortable: true },
				{ title: "Percentage", value: "payt_percentage", sortable: true },
				{ title: "Desc", value: "payt_desc", sortable: true },
				// { title: "Unit Cost", value: "unit_cost", sortable: true },
				{ title: "Qty", value: "qty", sortable: true },
				{ title: "Total", value: "payt_total", sortable: true },
				{ title: "Payable Date", value: "payable_date", sortable: true },
				{ title: "Amount Paid", value: "amount_paid", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],
			searchPayables: "",
			payablesPerPage: 10,
			payables: [],
			payableHeaders: [
				// { title: "#" value: "index", sortable: true },
				{ title: "Invoice Ref", value: "invoice_id", sortable: true },
				{ title: "Service", value: "service", sortable: true },
				{ title: "Desc", value: "description", sortable: true },
				{ title: "Unit", value: "unit_cost", sortable: true },
				{ title: "Qty", value: "qty", sortable: true },
				{ title: "Total (USD)", value: "total", sortable: true },
				{ title: "Actions", value: "actions", sortable: true },
			],
			searchSchedules: "",
			schedulesPerPage: 10,
			schedules: [],
			scheduleHeaders: [
				// { title: "Invoice Ref", value: "invoice_id", sortable: true },
				{ title: "Category", value: "payt_category", sortable: true },
				{ title: "Percentage", value: "payt_percentage", sortable: true },
				{ title: "Description", value: "plan_desc", sortable: true },
				// { title: "Unit Cost", value: "unit_cost", sortable: true },
				{ title: "Qty", value: "qty", sortable: true },
				{ title: "Total (USD)", value: "total_due", sortable: true },
				{ title: "Date", value: "payable_date", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			searchPayments: "",
			paymentsPerPage: 10,
			payments: [],
			paymentHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Category", value: "payt_category", sortable: true },
				{ title: "Total (USD)", value: "payt_total", sortable: true },
				{ title: "Plan %", value: "payt_percentage", sortable: true },
				{ title: "Desc", value: "payt_desc", sortable: true },
				{ title: "Date", value: "payable_date", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			searchSuppliers: "",
			suppliersPerPage: 10,
			supplierPayts: [],
			supplierHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Supplier", value: "supplier", sortable: true },
				{ title: "Payt Type", value: "payt_type", sortable: true },
				{ title: "Amount (USD)", value: "amount_usd", sortable: true },
				{ title: "Amount (UGX)", value: "amount_ugx", sortable: true },
				{ title: "Status", value: "status", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			openPanels: {
				invoicePayables: [0],
				invoicePayments: [0],
				supplierPayments: [0],
			},
		};
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/finance/");
		},
		invoicesComputed() {
			if (this.invoices && this.invoices.data) {
				return this.invoices.data.map((invoice, index) => {
					invoice.index = index;
					return invoice;
				});
			}
		},
		payablesComputed() {
			if (this.payables && this.payables.data) {
				return this.payables.data.map((payable, index) => {
					payable.index = index;
					return payable;
				});
			}
		},
		paymentsComputed() {
			if (this.payments && this.payments.data) {
				return this.payments.data.map((payment, index) => {
					payment.index = index;
					return payment;
				});
			}
		},
		schedulesComputed() {
			if (this.schedules && this.schedules.data) {
				return this.schedules.data.map((schedule, index) => {
					schedule.index = index;
					return schedule;
				});
			}
		},
		supplierComputed() {
			if (this.supplierPayts && this.supplierPayts.data) {
				return this.supplierPayts.data.map((supplier, index) => {
					supplier.index = index;
					return supplier;
				});
			}
		},
		filteredPayables() {
			if (!this.payables || !this.payables.data) {
				return [];
			}

			// If no invoice is selected, return all payables
			if (!this.selectedInvoice) {
				return this.payables.data;
			} else {
				return this.payables.data.filter(
					(item) => item.invoice_id == this.selectedInvoice.id
				);
			}
		},
		filteredSchedules() {
			if (!this.schedules || !this.schedules.data) {
				return [];
			}

			// If no invoice is selected, return all schedules
			if (!this.selectedInvoice) {
				return this.schedules.data;
			} else {
				return this.schedules.data.filter(
					(item) => item.invoice_id == this.selectedInvoice.id
				);
			}
		},
		filteredPayments() {
			if (!this.payments || !this.payments.data) {
				return [];
			}

			// If no invoice is selected, return all payments
			if (!this.selectedInvoice) {
				return this.payments.data;
			} else {
				return this.payments.data.filter(
					(item) => item.invoice_id == this.selectedInvoice.id
				);
			}
		},
		filteredSupplierPayts() {
			if (!this.supplierPayts || !this.supplierPayts.data) {
				return [];
			}

			// If no invoice is selected, return all suppliers
			if (!this.selectedInvoice) {
				return this.supplierPayts.data;
			} else {
				return this.supplierPayts.data.filter(
					(item) => item.invoice_id == this.selectedInvoice.id
				);
			}
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent) {
					return `${item.reference_number} (${item.client}) ${
						item.agent ? item.agent.name : "None"
					}`;
				}
			};
		},
		invoiceSelect() {
			return (item) => {
				if (item && item.reference && item.client_ref && item.agent) {
					return `${item.reference} (${item.client_ref}) ${
						item.agent ? item.agent.name : "None"
					}`;
				}
			};
		},
	},
	methods: {
		async tourDetails(event) {
			// invoice details
			this.tourInvoice.tour_id = event;
			this.tourInvoice.client_ref = event.client;
			this.tourInvoice.agent_id = event.agent;
			this.tourInvoice.reference = event.reference_number;
		},
		async invoiceDetails(event) {
			// invoice details
			this.invoicePayable.invoice_id = event;
			this.invoiceSchedule.invoice_id = event;
			this.invoicePayment.invoice_id = event;
			this.supplierPayment.invoice_id = event;
		},
		_tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
		async selectTour(event) {
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			// this.showMessage("Tour " + event.reference_number + " selected!");
			await this.tourDetails(event);
			// await this.manageInvoices("None", "fetch");
		},
		async selectInvoice(event) {
			sessionStorage.removeItem("selected_invoice");
			sessionStorage.setItem("selected_invoice", JSON.stringify(event));
			this.selectedInvoice = event;
			this.showMessage("Invoice " + event.reference + " selected!");

			await this.selectTour(event.tour);
			await this.invoiceDetails(event);
			await this.generateInvoice();
			// await this.managePayables("None", "fetch");
			// await this.manageSchedules("None", "fetch");
			// await this.managePayments("None", "fetch");
			// await this.manageSupplierPayts("None", "fetch");
		},
		selectItem(item, mode) {
			this.invoicePayable.description = "";
			if (mode == "extras") {
				this.invoicePayable.description =
					item.activity_name + ": " + this.invoicePayable.qty + " pax";
			} else if (this.invoicePayable.qty) {
				if (this.invoicePayable.service == "Safari Guests") {
					this.invoicePayable.description =
						"Ground Programme: " + this.invoicePayable.qty + " pax";
				} else if (this.invoicePayable.service == "Gorilla Permit") {
					this.invoicePayable.description =
						"Gorilla Trekking: " + this.invoicePayable.qty + " pax";
				} else if (this.invoicePayable.extra_id) {
					this.invoicePayable.description =
						item.activity_name + ": " + this.invoicePayable.qty + " pax";
				}
			}
		},
		selectSchedule(item, mode) {
			this.invoiceSchedule.plan_desc = "";
			if (mode == "extras") {
				this.invoiceSchedule.plan_desc =
					item.activity_name + ": " + this.invoiceSchedule.qty + " pax";
			} else if (this.invoiceSchedule.qty) {
				if (this.invoiceSchedule.service == "Safari Guests") {
					this.invoiceSchedule.plan_desc =
						"Ground Programme: " + this.invoiceSchedule.qty + " pax";
				} else if (this.invoiceSchedule.service == "Gorilla Permit") {
					this.invoiceSchedule.plan_desc =
						"Gorilla Trekking: " + this.invoiceSchedule.qty + " pax";
				} else if (this.invoiceSchedule.activity_id) {
					this.invoiceSchedule.plan_desc =
						item.activity_name + ": " + this.invoiceSchedule.qty + " pax";
				}
			}
		},
		async generateInvoice() {
			this.pdfLoading = true;
			try {
				const selectedTour = JSON.parse(
					sessionStorage.getItem("selected_tour")
				);
				const logo = await this.imageBase64("/images/speke_banner_black.png");
				const pdfUrl = await this.generateTourInvoice(
					// selectedInvoice, selectedTour, invoiceSchedule, invoicePayables, invoicePayments, logoImage
					this.selectedInvoice,
					selectedTour,
					this.filteredSchedules,
					this.filteredPayables,
					this.filteredPayments,
					logo
				);
				this.pdfDocument = pdfUrl;
			} catch (error) {
				console.error("Tour Invoice Generation Error:", error);
				this.showError("Failed to generate tour invoice");
			} finally {
				this.pdfLoading = false;
			}
		},
		async openModal(modal, mode) {
			this.loadModalData = true;

			try {
				if (modal == "invoices" && !this.invoiceData) {
					this.invoiceData = true;
					await Promise.all([
						this.getInfinites("agents"),
						// this.getInfinites("activities"),
					]);
				}

				if (
					(modal == "payables" ||
						modal == "schedules" ||
						modal == "payments" ||
						modal == "suppliers") &&
					!this.paymentData
				) {
					this.paymentData = true;

					await Promise.all([
						this.getInfinites("suppliers"),
						this.getInfinites("currencies"),
						this.getInfinites("types"),
					]);
				}
			} catch (error) {
				console.error("Error loading data:", error);
			} finally {
				// Hide loading indicator
				this.loadModalData = false;
			}

			var user_id = sessionStorage.getItem("user_id");
			if (modal == "invoices") {
				if (mode == "update") {
					this.tourInvoice.updated_by = user_id;
					this.editMode = true;
					this.invoicesModal = true;
				} else {
					this.tourDetails(this.selectedTour);
					this.tourInvoice.created_by = user_id;
					this.editMode = false;
					this.invoicesModal = true;
				}
			} else if (modal == "payables") {
				if (mode == "update") {
					this.invoicePayable.updated_by = user_id;
					this.editMode = true;
					this.payablesModal = true;
				} else {
					this.invoicePayable.reset();
					this.invoicePayable.qty = this.selectedTour.pax;
					this.invoicePayable.created_by = user_id;
					this.editMode = false;
					this.payablesModal = true;
				}
			} else if (modal == "schedules") {
				if (mode == "update") {
					this.invoiceSchedule.updated_by = user_id;
					this.editMode = true;
					this.schedulesModal = true;
				} else {
					this.invoiceSchedule.reset();
					this.invoiceSchedule.qty = this.selectedTour.pax;
					this.invoiceSchedule.created_by = user_id;
					this.editMode = false;
					this.schedulesModal = true;
				}
			} else if (modal == "payments") {
				if (mode == "update") {
					this.invoicePayment.updated_by = user_id;
					this.editMode = true;
					this.paymentsModal = true;
				} else {
					this.invoicePayment.reset();
					this.invoicePayment.created_by = user_id;
					this.editMode = false;
					this.paymentsModal = true;
				}
			} else if (modal == "suppliers") {
				if (mode == "update") {
					this.supplierPayment.updated_by = user_id;
					this.editMode = true;
					this.supplierModal = true;
				} else {
					this.supplierPayment.reset();
					this.supplierPayment.created_by = user_id;
					this.editMode = false;
					this.supplierModal = true;
				}
			} else if (modal == "preview") {
				if (!this.selectedInvoice) {
					this.showInfo("Please select an invoice first.");
					return;
				}
				this.pdfDocument = "";
				this.previewModal = true;
				await this.generateInvoice();
			}
		},

		closeModal(modal) {
			if (modal == "invoices") {
				this.editMode = false;
				this.invoicesModal = false;
				this.tourInvoice.reset();
				this.tourInvoice.errors.clear();
			} else if (modal == "payables") {
				this.editMode = false;
				this.payablesModal = false;
				this.invoicePayable.reset();
				this.invoicePayable.errors.clear();
			} else if (modal == "schedules") {
				this.editMode = false;
				this.schedulesModal = false;
				this.invoiceSchedule.reset();
				this.invoiceSchedule.errors.clear();
			} else if (modal == "payments") {
				this.editMode = false;
				this.paymentsModal = false;
				this.invoicePayment.reset();
				this.invoicePayment.errors.clear();
			} else if (modal == "suppliers") {
				this.editMode = false;
				this.supplierModal = false;
				this.supplierPayment.reset();
				this.supplierPayment.errors.clear();
			} else if (modal == "preview") {
				this.previewModal = false;
				this.pdfDocument = "";
			}
		},

		async getInfinites(mode) {
			var query, api;
			if (mode == "agents") {
				api = this.api + this.prefix + "/masters/agents";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.infiniteAgents = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "tours") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTours = [];
					this.infiniteTours = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "activities") {
				api = this.api + this.prefix + "/masters/activitiez";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteActivities = [];
					this.infiniteActivities = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "suppliers") {
				api = this.api + this.prefix + "/masters/suppliers";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.supplierList = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "currencies") {
				api = this.api + this.prefix + "/masters/currencies";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.currencyList = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "types") {
				api = this.api + this.prefix + "/masters/costtype";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.costTypes = [];
					this.costTypes = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageInvoices(event, mode) {
			var query, api;
			if (mode == "fetch") {
				// if (this.selectedTour !== null) {}
				// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
				api = this.api + this.prefix + "/finance/invoice";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.invoices = [];
					this.invoices = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/finance/invoice";
				query = await this.postData(api, this.tourInvoice);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("invoices");
					this.manageInvoices("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/invoice/" + event.id;
				query = await this.putData(api, this.tourInvoice);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("invoices");
					this.manageInvoices("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourInvoice.reset();
				this.tourInvoice.fill(event);
				const details =
					event.tour.reference_number +
					" (" +
					event.client_ref +
					") " +
					event.agent.name;
				event.tour.details = details;
				this.tourDetails(event.tour);
				this.openModal("invoices", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Invoice?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/invoice/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("invoices");
						this.manageInvoices("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageSchedules(event, mode) {
			var query, api;
			if (mode == "fetch") {
				// Fetch all schedules (not filtered by invoice)
				api = this.api + this.prefix + "/finance/ischedule";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.schedules = [];
					this.schedules = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.invoiceSchedule.invoice_id = this.selectedInvoice;
				api = this.api + this.prefix + "/finance/ischedule";
				query = await this.postData(api, this.invoiceSchedule);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("schedules");
					this.manageSchedules("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/ischedule/" + event.id;
				query = await this.putData(api, this.invoiceSchedule);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("schedules");
					this.manageSchedules("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.invoiceSchedule.reset();
				this.invoiceSchedule.fill(event);
				this.invoiceSchedule.invoice_id = event.invoice;
				this.openModal("schedules", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Schedule?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/ischedule/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("schedules");
						this.manageSchedules("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async managePayables(event, mode) {
			var query, api;
			if (mode == "fetch") {
				// Fetch all payables (not filtered by invoice)
				api = this.api + this.prefix + "/finance/ipayable";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.payables = [];
					this.payables = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.invoicePayable.invoice_id = this.selectedInvoice;
				api = this.api + this.prefix + "/finance/ipayable";
				query = await this.postData(api, this.invoicePayable);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("payables");
					this.managePayables("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/ipayable/" + event.id;
				query = await this.putData(api, this.invoicePayable);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("payables");
					this.managePayables("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.invoicePayable.reset();
				console.log(event);
				this.invoicePayable.fill(event);
				this.invoicePayable.invoice_id = event.invoice;
				this.openModal("payables", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Item?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/ipayable/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("payables");
						this.managePayables("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async managePayments(event, mode) {
			var query, api;
			if (mode == "fetch") {
				// Fetch all payments (not filtered by invoice)
				api = this.api + this.prefix + "/finance/ipayment";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.payments = [];
					this.payments = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.invoicePayment.invoice_id = this.selectedInvoice;
				api = this.api + this.prefix + "/finance/ipayment";
				query = await this.postData(api, this.invoicePayment);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("payments");
					this.managePayments("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/ipayment/" + event.id;
				query = await this.putData(api, this.invoicePayment);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("payments");
					this.managePayments("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.invoicePayment.reset();
				this.invoicePayment.fill(event);
				this.invoicePayment.invoice_id = event.invoice;
				this.openModal("payments", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Payment?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/ipayment/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("payments");
						this.managePayments("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageSupplierPayts(event, mode) {
			var query, api;
			if (mode == "fetch") {
				// Fetch all supplier payments (not filtered by invoice)
				api = this.api + this.prefix + "/finance/supplier-payt";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.supplierPayts = [];
					this.supplierPayts = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.supplierPayment.invoice_id = this.selectedInvoice;
				this.supplierPayment.tour_id = this.selectedInvoice.tour;
				api = this.api + this.prefix + "/finance/supplier-payt";
				query = await this.postData(api, this.supplierPayment);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("suppliers");
					this.manageSupplierPayts("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/finance/supplier-payt/" + event.id;
				query = await this.putData(api, this.supplierPayment);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("suppliers");
					this.manageSupplierPayts("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.supplierPayment.reset();
				this.supplierPayment.fill(event);
				this.supplierPayment.invoice_id = event.invoice;
				this.supplierPayment.payment_type = event.type;
				this.supplierPayment.currency = event.currency;
				this.supplierPayment.supplier_id = event.supplier;
				this.openModal("suppliers", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this Supplier Payment?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/finance/supplier-payt/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("suppliers");
						this.manageSupplierPayts("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
	},
	async created() {
		await this.getInfinites("tours");
		await this.manageInvoices("None", "fetch");

		if (this.selectedTour == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
				this.selectTour(selected);
			}
		}

		if (this.selectedInvoice == null) {
			if (sessionStorage.getItem("selected_invoice") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_invoice"));
				this.selectedInvoice = selected;
				this.selectInvoice(selected);
			}
		}

		await Promise.all([
			this.managePayables("None", "fetch"),
			this.manageSchedules("None", "fetch"),
			this.managePayments("None", "fetch"),
			this.manageSupplierPayts("None", "fetch"),
		]);

		if (this.selectedInvoice && !this.currentRoute) {
			await this.generateInvoice();
		}
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {
		clearInterval(this.timer);
	},
};
</script>

<style scoped>
</style>



